
import React, { ChangeEvent, KeyboardEvent, useState } from "react"
import http from './../../Service/http';
import { student } from "../../store/student"
import Input from './../Select/Input';
import { BsSearch } from 'react-icons/bs';

function StudentSearchByName() {

    const [ searchText, setText ] = useState<string>('')
    const hundleText = ( e: ChangeEvent<HTMLInputElement> ) => {
        setText(String(e.target.value))
    }

    const getStudentsByName = async () => {
        const res = await http.post("/student-by-name", {
            SearchNameSt: searchText
        })
        student.newStudents(res.data.data.StudentListName)
    }

    return ( 
        <>
        <div style={{ margin: "0 auto", width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "center"}}>
            <Input type = {"search"}
                value={ searchText }
                oninput ={setText}  
                placeholder ={ ""}
                style={{ width: "396px"}}
                keyDown={(e: KeyboardEvent<HTMLInputElement>) => {
                    if(e.key == "Enter"){
                        getStudentsByName()
                    }
                }} />
            <BsSearch className='search_icon' onClick={getStudentsByName} />
        </div>
        </>
     );
}

export default StudentSearchByName;